module.exports = __webpack_public_path__ + "img/bg6-5.59274874.png";